import { Link } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/store';
import { logoutUser } from '../../features/user/userSlice';

import { Col, Row, Flex } from 'antd';
import { LogoutOutlined, UserOutlined, SettingOutlined, ProjectOutlined, TeamOutlined, FileTextOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import LanguageTabs from './LanguageTabs';

import logo from '../../assets/images/logo.png';

const NavBar: React.FC = () => {
  const { loggedIn, user, rol } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isAdmin = rol === 'Administrador' || rol === 'Empresa' || user?.is_staff;
  const isSettingsAdmin = rol === 'Administrador' || user?.is_staff;
  return loggedIn ? (
    <Row className='navbar'>
      <Col span={4} className='logo-menu-container'>
        <img src={logo} alt='logo' className='logo-menu' />
      </Col>
      <Col span={20}>
        <Flex justify={'flex-end'} align={'center'} className='menu-container' component={'ul'}>
          <li className='menu-item' title={t('Lista de Proyectos')}>
            <Link to='/proyectos'>
              <ProjectOutlined /> {t('Proyectos')}
            </Link>
          </li>

          {isAdmin ? (
            <li className='menu-item'>
              <Link to='/usuarios'>
                <TeamOutlined /> {t('Usuarios')}
              </Link>
            </li>
          ) : null}

          {isSettingsAdmin ? (
            <li className='menu-item'>
              <Link to='/leads' title={t('Leads')}>
                <FileTextOutlined /> {t('Leads')}
              </Link>
            </li>
          ) : null}

          {isSettingsAdmin ? (
            <li className='menu-item'>
              <Link to='/configuraciones' title={t('Configuraciones')}>
                <SettingOutlined /> {t('Configuraciones')}
              </Link>
            </li>
          ) : null}

          <li className='menu-item'>
            <Link to='/perfil' title={t('Perfil')}>
              <UserOutlined /> {user.username}{' '}
            </Link>
          </li>
          <li className='menu-item'>
            <LanguageTabs compact />
          </li>
          <li className='menu-item' onClick={() => dispatch(logoutUser())}>
            <LogoutOutlined title={t('Cerrar Sesión')} />
          </li>
        </Flex>
      </Col>
    </Row>
  ) : null;
};

export default NavBar;
